module.exports = __webpack_public_path__ + "img/comment-logo.efb1ccd9.png";